export const FETCH_PERSON_ASSETS_END = "FETCH_PERSON_ASSETS_END";
export const LOAD_PERSON_ASSET_TO_EDIT = "LOAD_PERSON_ASSET_TO_EDIT";
export const RESET_DEFAULT_NEW_PERSON_ASSET = "RESET_DEFAULT_NEW_PERSON_ASSET";
export const RESET_DEFAULT_PERSON_ASSET_TO_EDIT = "RESET_DEFAULT_PERSON_ASSET_TO_EDIT";
export const RESET_DEFAULT_ASSET_TO_EDIT = "RESET_DEFAULT_ASSET_TO_EDIT";
export const TOGGLE_EDIT_PERSON_ASSET_DIALOG = "TOGGLE_EDIT_PERSON_ASSET_DIALOG";
export const TOGGLE_NEW_PERSON_ASSET_DIALOG = "TOGGLE_NEW_PERSON_ASSET_DIALOG";
export const TOGGLE_PERSON_ASSET_EDIT_STATE = "TOGGLE_PERSON_ASSET_EDIT_STATE";
export const UPDATE_ADD_PERSON_ASSET_FIELD = "UPDATE_ADD_PERSON_ASSET_FIELD";
export const UPDATE_EDIT_PERSON_ASSET_FIELD = "UPDATE_EDIT_PERSON_ASSET_FIELD";
export const UPDATE_NEW_PERSON_ASSET = "UPDATE_NEW_PERSON_ASSET";
export const UPDATE_PERSON_ASSET_FIELD = "UPDATE_PERSON_ASSET_FIELD";
export const FILTER_ASSETS = "FILTER_ASSETS";
export const FILTER_PERSON_ASSET_LIST_BY_PERSON_ID = "FILTER_PERSON_ASSET_LIST_BY_PERSON_ID";
export const FILTER_PERSON_ASSET_LIST_BY_ASSET_TYPE = "FILTER_PERSON_ASSET_LIST_BY_ASSET_TYPE";
export const FILTER_PERSON_ASSET_LIST_BY_ASSET_STATUS = "FILTER_PERSON_ASSET_LIST_BY_ASSET_STATUS";

